import { render, staticRenderFns } from "./mentStatistics.vue?vue&type=template&id=472c8810&scoped=true"
import script from "./mentStatistics.vue?vue&type=script&lang=js"
export * from "./mentStatistics.vue?vue&type=script&lang=js"
import style0 from "./mentStatistics.vue?vue&type=style&index=0&id=472c8810&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c8810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472c8810')) {
      api.createRecord('472c8810', component.options)
    } else {
      api.reload('472c8810', component.options)
    }
    module.hot.accept("./mentStatistics.vue?vue&type=template&id=472c8810&scoped=true", function () {
      api.rerender('472c8810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/staff/mentStatistics.vue"
export default component.exports